import {useMutation, useQueryClient} from '@tanstack/react-query';

import {setDefaultParticipantName} from '../api';
import {QUERY__PARTICIPANTS} from '../queryKeys';

export const useSetDefaultParticipantName = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      participantId,
      name,
    }: {
      participantId: string;
      name: string;
    }) => setDefaultParticipantName(participantId, name),
    onSuccess: (_data, {participantId}) => {
      void queryClient.invalidateQueries({
        queryKey: [QUERY__PARTICIPANTS, participantId],
      });
    },
  });
};
